import React from 'react';
import './skeleton-loading.less';

function SkeletonLoading({loading, children}) {
    if (!loading) {
        return children;
    }

    let SKELETON_CLASS = 'skeleton-loading';
    return React.Children.map(children, (child) => {
        let className = child.props.className || '';
        className = (className.length ? `${className} ${SKELETON_CLASS}` : SKELETON_CLASS);
        return React.cloneElement(child, {className});
    });
}

export default SkeletonLoading;


// WEBPACK FOOTER //
// ./src/universal/abacus/skeleton-abc/skeleton-loading.js